export default __webpack_public_path__ + "static/theprotocol_logo_light (1)-f8c66b57d6f29fa474f1daae201cdde4.png";